module.exports = __webpack_public_path__ + "assets/google-play-en.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/stores/google-play-en.svg
// module id = 437
// module chunks = 19